
import React from "react";
import BusinessDashboard from "@/components/magic-dashboard/BusinessDashboard";

export default function MagicDashboardPage() {
  return <BusinessDashboard />;
}
